import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[5/7] overflow-hidden">
          <img
            src={comic.cover}
            alt={`${comic.title} - 43423漫画网`}
            title={`${comic.title} 免费在线阅读`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 text-[10px] px-2 py-0.5 rounded-full bg-primary-500 text-background-50 font-medium">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 text-[10px] px-2 py-0.5 rounded-full bg-secondary-500 text-background-50 font-medium">
            完结
          </span>
        )}
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5">
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-eye-line text-[10px]"></i>
            </span>
            {formatViews(comic.views)}
          </span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-[10px] text-accent-500"></i>
            </span>
            {comic.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}